import { Component, forwardRef, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { empty } from "../../functions";
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

const noop = () => {};

export const CORE_SELECTOR_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CoreSelectorComponent),
  multi: true,
};

@Component({
  selector: "app-core-selector",
  templateUrl: "./core-selector.component.html",
  styleUrls: ["./core-selector.component.scss"],
  providers: [CORE_SELECTOR_CONTROL_VALUE_ACCESSOR],
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
})
export class CoreSelectorComponent implements ControlValueAccessor {
  @Input() selectorValue = "value";
  @Input() selectorLabel = "label";

  // Inputs for component
  @Input() title = "";
  @Input() description = "";
  @Input() filterOptions: any = [];
  @Input() class = "";
  // Only show limited amount of items at once
  @Input() limit = 10;

  @Input() type = "checkbox";

  collapseLimitedItems = true;

  expandedItems = new Set<string>();

  toggleExpanded(itemValue: string) {
    if (this.expandedItems.has(itemValue)) {
      this.expandedItems.delete(itemValue);
    } else {
      this.expandedItems.add(itemValue);
    }
  }

  filterModelValues = [];
  filterModelValue = "";
  public filterValues = [];

  /**
   * Ng Class
   */

  // The internal data model
  private innerValue: any = [];

  // Placeholders for the callbacks which are later providesd
  // by the Control Value Accessor
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  // get accessor
  get value(): any {
    return this.innerValue;
  }

  // set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  // Set touched on blur
  onBlur() {
    this.onTouchedCallback();
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    this.innerValue = value;
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  /**
   * Toggle checkbox filter option
   *
   * @param $value
   */
  toggleCheckboxFilter($value: any) {
    if (empty($value)) return;
    if (empty(this.value)) this.value = [];

    if (this.value.indexOf($value) > -1) {
      this.value.splice(this.value.indexOf($value), 1);
    } else {
      this.value.push($value);
    }

    // Write new value
    // this.writeValue(this.filterValues);

    // Callback for registering changes programmatically
    this.onChangeCallback(this.value);
  }

  /**
   * Set chosen radio filter value
   *
   * @param $value
   */
  setRadioValue($value: any) {
    this.writeValue($value);

    // Callback for registering changes programmatically
    this.onChangeCallback(this.value);
  }

  /**
   * Add a filter text
   *
   * @param $value
   * @param $filter
   */
  addFilterText($value: any) {
    if (!$value) {
      return;
    }

    this.value.push($value);

    // Callback for registering changes programmatically
    this.onChangeCallback(this.value);

    // Reset input
    this.filterModelValue = "";
  }

  /**
   * Delete an industry
   *
   * @param propertyId
   * @param industryItem
   */
  deleteFilterText($value: any) {
    if (this.value.indexOf($value) > -1) {
      this.value.splice(this.value.indexOf($value), 1);
    }

    // Callback for registering changes programmatically
    this.onChangeCallback(this.value);
  }
}
